export default __webpack_public_path__ + "static/media/shape2.18abca94.svg";